import { useState } from 'react';

// Sorting library function
export function useSorting(
  initialField = 'id',
  initialOrder: 'ASC' | 'DESC' = 'ASC'
) {
  const [sorting, setSorting] = useState([
    { id: initialField, desc: initialOrder === 'DESC' },
  ]);

  return {
    sorting,
    onSortingChange: setSorting,
    // eslint-disable-next-line no-nested-ternary
    order: !sorting.length ? initialOrder : sorting[0].desc ? 'DESC' : 'ASC',
    field: sorting.length ? sorting[0].id : initialField,
  };
}
